export default class Theme {
    private readonly _id: number;
    private readonly _title: string;
    private readonly _slug: string;
    private readonly _description: string;

    public constructor(item: any) {
        this._id = item.id;
        this._title = item.title;
        this._slug = item.slug;
        this._description = item.description;
    }

    get id(): number {
     return this._id;
    }

    get title(): string {
        return this._title;
    }
}
